import FindDuplicateContacts from './FindDuplicateContacts';

// The layout is the properties Find Dups popup; this only adds the contact
// rules' own bits on top of it.
import '../FindDuplicateProperties/FindDuplicateProperties.scss';
import './FindDuplicateContacts.scss';

export default FindDuplicateContacts;
